import { useParams } from "react-router-dom";
import "./style.css";
import React, { useEffect } from "react";
function AppLink() {
  const { id } = useParams();
  const redirectToMobileApp = () => {
    const userAgent = navigator.userAgent.toLowerCase();
    const isMobile = /mobile/.test(userAgent);

    if (isMobile && window.location.href.indexOf("redirected=true") === -1) {
      // Check if Connectyfy app is installed
      const timeout = setTimeout(() => {
        window.location.href =
          "https://play.google.com/store/apps/details?id=com.connectyfy"; // Fallback URL
      }, 500);

      window.location.href = `connectyfy:///share?id=${id}`;

      // If the Connectyfy app is installed, the user will be redirected and this code will not execute.
      clearTimeout(timeout);
    }
  };

  useEffect(() => {
    redirectToMobileApp();
  }, []);
  return (
    <div className="mainlink">
      <div>
        <h1 className="maintextLink">Redirect to Mobile App {id} </h1>
        {/* <button onClick={handleRedirect}>Redirect to Mobile App</button> */}
      </div>
    </div>
  );
}

export default AppLink;
